module.exports = __webpack_public_path__ + "img/contract_not_complete.5e2b0c0c.svg";